import React from "react";

export const RedoTaskButton = (props) => {
    return <button onClick={props.clickHandler} className={props.className + " button"} {...props} />;
};
